module.exports = __webpack_public_path__ + "static/media/play-store-dark.d10e4265.svg";